import React, {useEffect, useState} from 'react'
import DrawDialog from "../../components/drawer/dialog/DrawDialog";
import useTranslate from "../local/useTranslate";
import {renderIfElse} from "../../views/Shared";
import {Alert, Button, message} from "antd";
import copyToClipboard from "copy-to-clipboard";


const InAppBrowserRedirect = ({children}) => {
    const t = useTranslate();
    const [inAppBrowser, setInAppBrowser] = useState(false);

    useEffect(() => {
        // Kiểm tra trình duyệt Zalo
        setInAppBrowser(isInAppBrowser());
    }, []);

    const isInAppBrowser = () => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera || "";
        return /Zalo/i.test(userAgent); // Kiểm tra xem có phải Zalo hay không
    };

    const openInBrowser = () => {
        const url = window.location.href;
        copyToClipboard(url)
        message.info(t("The URL has been copied! You can paste and open this page in Safari, Chrome, or Firefox."))
        // navigator.clipboard.writeText(url).then(() => {
        //     alert(t("The URL has been copied! You can paste and open this page in Safari, Chrome, or Firefox."));
        // }).catch(() => {
        //     alert(t("Cannot copy the URL."));
        // });
    };

    return renderIfElse(inAppBrowser,
        <DrawDialog
            width={450}
            visible={true}
            title={
                <div className="text-center font-bold text-color-000 tracking-wider">
                    {t('Open in browser')}
                </div>
            }
            closable={false}
            component={<React.Fragment/>}>
            {(isToggle, toggle) => isToggle && (
                <div className="flex flex-col flex-center gap-2 space-y-6">
                    <Alert
                        type="warning"
                        className="background border-primary-200"
                        message={
                            t('Welcome to Kristo Network')
                        }
                        description={
                            <div className="flex flex-col space-y-6 items-center justify-center w-full py-3">
                                <p>
                                    {t('You are opening this website in the in-app browser of the app. For the best experience, please use the default browser on your device.')}
                                </p>
                                <Button onClick={openInBrowser}
                                        className="button-rounded-lg border-0 px-3"
                                        type={"primary"}>
                                    {t('copy link')}
                                </Button>
                            </div>
                        }
                    />

                </div>
            )}
        </DrawDialog>,
        null
    );
}

export default InAppBrowserRedirect
